export default {
  data() {
    return {
      editValue: this.defaultValue
    };
  },
  watch: {
    editValue(newValue) {
      this.$emit("updateValue", {
        value: newValue,
        attr: this.attr
      });
    }
  },
  props: ["title", "tips", "defaultValue", "options", "attr", "msg"]
};
